import client from '../httpClient';

const schedulesPostGuidanceApi = (params) => {
  return client.post('/guidances', JSON.stringify(params), { isShowLoading: false });
};

export default schedulesPostGuidanceApi;
